<template>
  <div class="callme_total_wrap hidden-xs-only">
<!--    <div class="callme_top_wrap"></div>-->
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="items_wrap">
          <div><img src="@/assets/img/home/logo.svg" alt="良悦科技" width="60%" /></div>
          <div class="item_options1">
            <span >综合咨询：<span class="number">400-033-9003</span></span>
            <span>售前咨询：13603710470</span>
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down">
        <div class="item_tit center"><img src="@/assets/img/home/qrcode.jpg" alt="" class="qr" />
        </div>
        <div class="item_options">
          <span class="gz">关注我们<br>了解最新动态</span>
        </div>
      </div>
        <div class="items_wrap"  style="margin-left: 80px">
          <div class="item_tit" @click="handleToRouter('/about')">关于良悦</div>
          <div class="item_options">
            <span @click="handleToRouter('/about')">公司介绍</span>
            <span @click="handleToRouter('/about')">专业优势</span>
            <span @click="handleToRouter('/about')">发展历程 </span>
          </div>
        </div>

        <div class="items_wrap">
          <div class="item_tit" @click="handleToRouter('/solution/0')">解决方案</div>
          <div class="item_options">
            <span @click="handleToRouter('/solution/rep')">企业资源计划管理</span>
            <span @click="handleToRouter('/solution/scm')">数字化供应链管理</span>
            <span @click="handleToRouter('/solution/mes')">智能制造执行管理</span>
            <span @click="handleToRouter('/solution/wms')">智能仓储管理</span>
            <span @click="handleToRouter('/solution/0')">更多方案</span>
          </div>
        </div>

        <div class="items_wrap">
          <div class="item_tit" @click="handleToRouter('/cooperation')">联系我们</div>
          <div class="item_options">
            <span @click="handleToRouter('/cooperation')">留言咨询</span>
            <span @click="handleToRouter('/cooperation')">项目合作</span>
            <span @click="handleToRouter('/cooperation')">试用体验 </span>
          </div>
        </div>
      </div>
      <div class="navigate_wrap">
        <div class="line1"><span>Copyright ©2025 河南良悦信息科技有限公司版权所有</span><span>豫ICP备2022018655号-1</span></div>
        <div class="line2"><span>一站式的工业智能化整体解决方案与服务，以ERP产品和智能制造解决方案为核心，涵盖MES、SCM、WMS、CRM等工业软件服务</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      cityInfomation: [
        {
          phone: '0571-86885326',
          eamil: 'Contact@hsmap.com',
          address: '浙江省杭州市滨江区阡陌路482号智慧e谷B座7楼',
        },
        {
          phone: '028-86713133',
          eamil: 'Contact@hsmap.com',
          address: '成都市高新区天晖路360号晶科一号1806室',
        },
        {
          phone: '0571-86885326（转）',
          eamil: 'Contact@hsmap.com',
          address: '北京市朝阳区安翔北里11号院北京创业大厦B座1005',
        },
        {
          phone: '15051586330',
          eamil: 'Contact@hsmap.com',
          address: '重庆市九龙坡区华岩镇华锦路26号',
        },
      ],
      showCity: 0,
    }
  },
  methods: {
    handleSelect(index) {
      this.showCity = parseInt(index) - 1
    },
    handleToRouter(url) {
      this.$router.replace(url)
    },
  },
}
</script>

<style lang="scss" scoped>

.callme_total_wrap {
  width: 100%;
  padding-top: 50px;
  background: #F5F7FA;
  .callme_bottom_wrap {
    width: 100%;
    background: #F5F7FA;
    color: #05102F;
    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 60px;
      border-bottom: solid #C7CAD1 1px;
      .items_wrap {
        width: 30%;
        margin-right: 50px;
        //text-align: center;
        //margin-right: 100px;
        .item_tit {
          cursor: pointer;
          width: 200px;
          color: rgba(37, 53, 84, 0.8);
          font-size: 16px;
          padding-left: 50px;
          font-weight: bold;
        }
        .center{
          text-align: center;
        }
        .qr{
          width:100% ;
          cursor: default;
        }

        .item_options1 {
          display: flex;
          width: 300px;
          flex-direction: column;
          span {
            color: rgba(37, 53, 84, 0.8);
            font-size: 14px;
            margin-top: 15px;
            text-align: left;
            .number{
              font-size: 20px;font-weight: bold;line-height: 30px
            }
          }
        }
        .item_options {
          display: flex;
          flex-direction: column;
          padding-left: 50px;
          span {

            color: rgba(37, 53, 84, 0.8);
            font-size: 13px;
            margin-top: 15px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300PX;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 14px;
            width: 300PX;
            height: 80px;
            p {
              margin-top: 30px;
            }
          }
          img {
            width: 100%;
            margin-top: 20px;
          }
          .gz{
            margin-top: 10px;text-align: center;cursor: unset
          }
        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 30px;
      padding-bottom: 30px;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      .line1{
        text-align: center;width: 100%
      }
      .line2{
        text-align: center;width: 100%;margin-top: 10px
      }
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 14px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #8491AB;
        padding-right: 20px;
        font-size: 12px;
        margin-right: 0;
      }
      p {
        font-size: 14px;
        color: #4e5557;
      }
    }
  }
}
</style>